import React from 'react';

import { SectionAddressWrapper, ButtonWrapper } from './styled';

interface IProps {
  contentData: any;
}

const SectionAddress = ({ contentData }: IProps) => (
  <SectionAddressWrapper>
    <p>{contentData.building.campus?.toLowerCase()}</p>
    <p>
      <span>Sede:</span> {contentData.building.sede?.toLowerCase()}
    </p>

    <p>{contentData.building.address?.toLowerCase()}</p>
    <ButtonWrapper
      target="_black"
      href={`http://www.google.com/maps/place/${contentData.building.coordinates.latitude},${contentData.building.coordinates.longitude}`}
    >
      <span>Ver mapa</span>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M11.925 6.3C12 6.225 12 6.075 12 6C12 5.925 12 5.775 11.925 5.7C11.85 5.625 11.85 5.55 11.775 5.475L6.525 0.225C6.225 -0.075 5.775 -0.075 5.475 0.225C5.175 0.525 5.175 0.975 5.475 1.275L9.45 5.25H0.75C0.3 5.25 0 5.55 0 6C0 6.45 0.3 6.75 0.75 6.75H9.45L5.475 10.725C5.175 11.025 5.175 11.475 5.475 11.775C5.625 11.925 5.85 12 6 12C6.15 12 6.375 11.925 6.525 11.775L11.775 6.525C11.85 6.45 11.925 6.375 11.925 6.3Z"
            fill="#5B36F2"
          />
        </g>
      </svg>
    </ButtonWrapper>
  </SectionAddressWrapper>
);

export default SectionAddress;
